import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doggyhub',
  templateUrl: './doggyhub.page.html',
  styleUrls: ['./doggyhub.page.scss'],
})
export class DoggyhubPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
